import { AxiosRequestConfig } from "../../Api/Interfaces";
import { DataDisplayerSingleSearchParam } from "../../DataDisplayer/Interfaces";
import BaseApp from "../BaseApp";

type searchParams = Array<DataDisplayerSingleSearchParam>

export interface SingleSectionInterface {
    id: number,
    title: string,
    slug: string,
    thumbnail: string,
    is_active: boolean,
    date_created: string,
    created_by: number,
    last_updated_on: string,
    updated_by: number,
    updated_by_name: string,
    created_by_name: string,
    order_num: number,
}

export const emptySectionDetails: SingleSectionInterface = {
    id: 0,
    title: "",
    slug: "",
    thumbnail: "",
    is_active: false,
    date_created: "",
    created_by: 0,
    last_updated_on: "",
    updated_by: 0,
    updated_by_name: "",
    created_by_name: "",
    order_num: 0
}

/**
 * Companies App
 */
export default class SectionsApp extends BaseApp {

    /**
     * App Name
     */
    appName: string = "sections"

    /**
     * App base end point path
     */
    appBaseEndPointPath: string = "sections"

    /**
     * Required fields
     */
    requiredFields = [
        "title"
    ]

    /**
     * Get single instance details by Slug
     */
    getSingleInstanceDetailsBySlug = (slug: string) => this.sendRequest({
        method: "GET",
        url: this.appBaseEndPointPath + `/section-by-slug/${slug}/details`,
        withCredentials: true
    })

    /**
     * List of categories
     */
    listOfCategories = async(slug: string, page: number, search: string | null, disablePagination: boolean, searchParams?: searchParams) => {

        let path: string = this.appBaseEndPointPath + `/section-by-slug/${slug}/categories/list`

        path += `?page=${page ? page : 1}`

        if (search !== null){
            path += "&search=" + search
        }

        if (searchParams && searchParams.length > 0){
            searchParams.map((searchParam: DataDisplayerSingleSearchParam) => {
                path += `&${searchParam.name}=${searchParam.value}`
            })
        }

        if (disablePagination){
            path += "&disable_pagination=1"
        }

        const config: AxiosRequestConfig = {
            method: "GET",
            url: path,
            withCredentials: true
        }

        return this.sendRequest(config)
    }

    /**
     * order
     */
    updateSectionsOrder = (categories: Array<SingleSectionInterface>) => this.sendRequest({
        method: "PUT",
        data: {
            posts: categories
        },
        url: this.appBaseEndPointPath + `/order/all-sections`,
        withCredentials: true
    })

    /**
     * List of categories
     */
    listOfSections = async(slug: string, page: number, search: string | null, disablePagination: boolean, searchParams?: searchParams) => {

        let path: string = this.appBaseEndPointPath

        path += `?page=${page ? page : 1}`

        if (search !== null){
            path += "&search=" + search
        }

        if (searchParams && searchParams.length > 0){
            searchParams.map((searchParam: DataDisplayerSingleSearchParam) => {
                path += `&${searchParam.name}=${searchParam.value}`
            })
        }

        if (disablePagination){
            path += "&disable_pagination=1"
        }

        const config: AxiosRequestConfig = {
            method: "GET",
            url: path,
            withCredentials: true
        }

        return this.sendRequest(config)
    }

    /**
     * Delete Many
     */
    deleteManySections = (records: Array<SingleSectionInterface>) => this.sendRequest({
        method: "DELETE",
        data: {
            records: records
        },
        url: this.appBaseEndPointPath + `/delete-many`,
        withCredentials: true
    })

}